import { render, staticRenderFns } from "./ResultCamp.vue?vue&type=template&id=670ad001&lang=html"
import script from "./ResultCamp.vue?vue&type=script&lang=js"
export * from "./ResultCamp.vue?vue&type=script&lang=js"
import style0 from "./ResultCamp.vue?vue&type=style&index=0&id=670ad001&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports